export default __webpack_public_path__ + "28b035efe4f39fd3358de86d89a5a60a.png";